export default "__VITE_PUBLIC_ASSET__0554cc44__"